import { Injectable } from '@angular/core';
import { ReportInventoryStocktakingGridQuery, ReportInventoryStocktakingGridQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ReportInventoryStocktakingGridQuery)
@Wrapper(ReportInventoryStocktakingGridQueryHandlerBase)
export class ReportInventoryStocktakingGridQueryHandler {
    public constructor(
        http: Http
    ) { }
}
